exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".control[data-v-5afd3306]{margin-bottom:10px;margin-top:5px}.no-padding[data-v-5afd3306]{padding-left:0!important;padding-right:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5afd3306","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/app-positions-control.vue
// module id = 95
// module chunks = 0